import { Radio } from "lucide-react";

export default function Livestreams() {
  return (
    <div className="p-6 md:p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <div className="w-12 h-12 rounded-xl bg-pink-500/20 flex items-center justify-center">
          <Radio className="w-6 h-6 text-pink-400" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-bold">Livestreams</h1>
          <p className="text-muted-foreground">Watch live sessions</p>
        </div>
      </div>

      {/* Empty State */}
      <div className="text-center py-12">
        <Radio className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="font-semibold text-foreground mb-2">No upcoming livestreams</h3>
        <p className="text-muted-foreground">Check back later for scheduled live sessions!</p>
      </div>
    </div>
  );
}
